// Generated from SVG to Code Figma Plugin

export const BaseLineVideoremake = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.49805 6.21775V3.9082C6.49805 3.13155 7.12765 2.50195 7.9043 2.50195H20.0918C20.8684 2.50195 21.498 3.13155 21.498 3.9082V16.0957C21.498 16.8724 20.8684 17.502 20.0918 17.502H17.7562"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M16.0957 6.49805H3.9082C3.13155 6.49805 2.50195 7.12765 2.50195 7.9043V20.0918C2.50195 20.8684 3.13155 21.498 3.9082 21.498H16.0957C16.8724 21.498 17.502 20.8684 17.502 20.0918V7.9043C17.502 7.12765 16.8724 6.49805 16.0957 6.49805Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M8.13672 10.8438C8.37512 10.7118 8.66637 10.7198 8.89746 10.8643L12.8975 13.3643C13.1167 13.5013 13.25 13.7414 13.25 14C13.25 14.2586 13.1167 14.4987 12.8975 14.6357L8.89746 17.1357C8.66637 17.2802 8.37512 17.2882 8.13672 17.1562C7.89825 17.0241 7.75 16.7726 7.75 16.5V11.5C7.75 11.2274 7.89825 10.9759 8.13672 10.8438Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
